<template>
  <el-dialog :visible.sync="show" :title="name" width="900px">
    <el-form ref="form" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
      <el-form-item prop="tenantId" label="企业">
        <el-select v-model="data.tenantId" placeholder="选择企业" clearable filterable style="width: 100%">
          <el-option v-for="(item, index) in tenantList" :key="index" :value="item.id"
            :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="deadline" label="到期时间">
        <el-date-picker v-model="data.deadline" type="datetime" placeholder="选择到期时间" clearable style="width: 100%"
          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item prop="payingInterval" label="缴费周期">
        <el-input v-model="data.payingInterval" placeholder="输入缴费周期"></el-input>
      </el-form-item>
      <el-form-item prop="payingAmount" label="缴费金额">
        <el-input v-model="data.payingAmount" placeholder="输入缴费金额" type="number" style="width: 760px"></el-input> 元
      </el-form-item>
      <el-form-item prop="payingAccountName" label="账户名称">
        <el-input v-model="data.payingAccountName" placeholder="输入账户名称"></el-input>
      </el-form-item>
      <el-form-item prop="payingAccountNum" label="账户号码">
        <el-input v-model="data.payingAccountNum" placeholder="输入账户号码"></el-input>
      </el-form-item>
      <el-form-item prop="payingAccountBank" label="开户银行">
        <el-input v-model="data.payingAccountBank" placeholder="输入开户银行"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div style="text-align: center">
        <el-button type="primary" style="width: 100%" @click="save" :loading="loading">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import XEUtils from 'xe-utils'

export default {
  data() {
    return {
      show: false,
      name: '',
      data: {},
      rules: {
        tenantId: [{ required: true, trigger: 'change', message: '选择企业' }],
        deadline: [{ required: true, trigger: 'change', message: '选择到期时间' }],
        payingInterval: [{ required: true, trigger: 'change', message: '输入缴费周期' }],
        payingAmount: [{ required: true, trigger: 'change', message: '输入缴费金额' }],
        payingAccountName: [{ required: true, trigger: 'change', message: '输入账户名称' }],
        payingAccountNum: [{ required: true, trigger: 'change', message: '输入账户号码' }],
        payingAccountBank: [{ required: true, trigger: 'change', message: '输入开户银行' }]
      },
      loading: false,
      platformList: [],
      tenantList: []
    }
  },
  methods: {
    display(e) {
      this.data = XEUtils.clone(e.data, true)
      this.name = e.name
      this.getTenantList()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
      this.show = true
    },

    getTenantList() {
      this.$axios.get('/account/tenant/all').then(res => {
        this.tenantList = res.data.data
      }).catch(() => {
      })
    },

    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = JSON.parse(JSON.stringify(this.data))
          this.$axios.post('/account/tenant/paying/create', params).then(() => {
            this.$message.success({ showClose: true, message: `${this.name}成功` })
            this.show = false
            this.$emit('init')
            this.loading = false
          }).catch(err => {
            console.log(`${this.name}失败`, err)
            this.loading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
